import React from 'react';
import { ScrollIntoViewAPI } from './api';
const Context = React.createContext(null);
export default Context;
export const APIConsumer = Context.Consumer;
export class ProvideAPI extends React.Component {
    constructor() {
        super(...arguments);
        this.api = new ScrollIntoViewAPI(this.props.dependencies);
    }
    render() {
        return (React.createElement(Context.Provider, { value: this.api }, this.props.children));
    }
}
//# sourceMappingURL=context.js.map